<img [ngSrc]="HORDES_IMG_REPO + 'icons/ap_small' + (locale === 'de' ? '' : '_' + locale) + '.gif'" width="16" height="16">
